module.exports = __webpack_public_path__ + "img/product_img_bg_small.9134058.webp";